import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { IFetchRankReportPayload } from '../types';

const FETCH_RANK_REPORT_KEY = 'FETCH_RANK_REPORT_QUERY';

/**
 * ----------------------------------------------------------------------------\
 * React Query hook for bid summary rank api management it will call
 *`fetchRankReports` api and give error loading success state with response
 */
export const useFetchRankReportQuery = (payload: IFetchRankReportPayload) => {
  const { brandId, brandIds, categoryId, groupIds, search } = payload;

  const localPayload = {
    ...(brandIds && brandIds?.length > 0 ? { brandIds } : {}),
    ...(brandId ? { categoryId } : {}),
    ...(categoryId ? { categoryId } : {}),
    ...(groupIds ? { groupIds } : {}),
    ...(search ? { search } : {}),
  };

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      FETCH_RANK_REPORT_KEY,
      brandId,
      brandIds,
      categoryId,
      groupIds,
      search,
    ],
    queryFn: () => BIDS_API.fetchRankReports(localPayload),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
